import { Configuration, PopupRequest } from "@azure/msal-browser";

// Environment variables for Azure AD configuration
const clientId = process.env.REACT_APP_AZURE_CLIENT_ID || '';
const authority = process.env.REACT_APP_AZURE_AUTHORITY || '';
const configuredRedirectUri = process.env.REACT_APP_REDIRECT_URI;

export function resolveRedirectUri(configuredUri: string | undefined, currentOrigin: string): string {
  if (!configuredUri) return currentOrigin;

  try {
    return new URL(configuredUri).origin === currentOrigin ? configuredUri : currentOrigin;
  } catch {
    return currentOrigin;
  }
}

const redirectUri = resolveRedirectUri(configuredRedirectUri, window.location.origin);
const apiScope = process.env.REACT_APP_API_SCOPE || '';

// Validate required environment variables
if (!clientId) {
  console.warn('REACT_APP_AZURE_CLIENT_ID is not set in environment variables');
}
if (!authority) {
  console.warn('REACT_APP_AZURE_AUTHORITY is not set in environment variables');
}

/**
 * sessionStorage key holding the URL a user was trying to reach before being
 * bounced to the sign-in page.
 *
 * React Router's `location.state` cannot be used on its own here: signing in is
 * a full-page navigation out to Azure AD and back, which discards in-memory
 * router state. sessionStorage survives that round trip and is cleared when the
 * tab closes.
 */
export const RETURN_URL_STORAGE_KEY = 'connect.returnUrl';

// Azure AD Configuration
export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority,
    redirectUri,
  },
  cache: {
    cacheLocation: "localStorage",
  },
};

// Scopes for ID token to be used at Microsoft Graph API endpoints.
export const loginRequest: PopupRequest = {
  scopes: ["User.Read", "User.ReadBasic.All"]
};

// API scopes
export const apiRequest = {
  scopes: [apiScope]
};

// Export environment config for use in other files
export const envConfig = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL ?? '',
  graphApiUrl: process.env.REACT_APP_GRAPH_API_URL || 'https://graph.microsoft.com/v1.0',
};
